import { useDrawer } from '../hooks/useDrawer';

type ChildrenContainerProps = {
	children: React.ReactNode;
};

const ChildrenContainer = ({ children }: ChildrenContainerProps) => {
	const { blockClass } = useDrawer();

	const renderClass = () =>
		blockClass && `vtex-store-drawer-0-x-childrenContainer--${blockClass} childrenContainer--${blockClass}`;

	return (
		<div className={`vtex-store-drawer-0-x-childrenContainer childrenContainer ${renderClass()} flex flex-grow-1`}>
			{children}
		</div>
	);
};

export default ChildrenContainer;
